var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgVPostpartum = function (_a) {
    var title = _a.title, titleId = _a.titleId, desc = _a.desc, descId = _a.descId, props = __rest(_a, ["title", "titleId", "desc", "descId"]);
    return (_jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId }, props, { children: [desc ? _jsx("desc", __assign({ id: descId }, { children: desc })) : null, title ? _jsx("title", __assign({ id: titleId }, { children: title })) : null, _jsx("g", __assign({ clipPath: "url(.clip0_12_2095)" }, { children: _jsx("path", { d: "M17 6c0 1.791-.785 3.4-2.03 4.499.493.161.955.348 1.342.538a4 4 0 1 1 .656 6.409l-2.76 2.761a1 1 0 0 1-1.415-1.414l2.76-2.761a3.982 3.982 0 0 1-.552-1.932A5.002 5.002 0 0 0 11 19v3h3A5.002 5.002 0 0 0 18.9 18L19 18c.722 0 1.4-.191 1.984-.526A7 7 0 0 1 14 24h-4a1 1 0 0 1-1-1v-4a7.003 7.003 0 0 1 4.996-6.709c-.608-.175-1.231-.291-1.722-.291H9.572a5.548 5.548 0 0 0-5.314 3.954c-.358 1.194-.368 2.405-.04 3.37.32.936.95 1.645 1.958 1.97a1 1 0 1 1-.614 1.904c-1.68-.543-2.74-1.77-3.237-3.23-.487-1.432-.436-3.077.017-4.589a7.549 7.549 0 0 1 4.641-4.922A6 6 0 1 1 17 6Zm-6-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm6 12a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z", fill: "currentColor" }) }))] })));
};
export default SvgVPostpartum;
